import {Component} from '@angular/core';
import {Events, IonicPage, NavController, NavParams, PopoverController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {CountryProvider} from "../../providers/country/country";
import {RecommendationThankYouPopoverPage} from "../recommendation-thank-you-popover/recommendation-thank-you-popover";
import {TermsConditionsServiceProvider} from "../../providers/terms-conditions-service/terms-conditions-service";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {UrlServiceProvider} from "../../providers/url-service/url-service";

@IonicPage()
@Component({
  selector: 'page-invite-barbershop',
  templateUrl: 'invite-barbershop.html',
})
export class InviteBarbershopPage {

  errors: {};
  loading: boolean;
  name: string;
  email: string;
  barbershop: string;
  country: string;
  barbershopWebsite: string;
  comments: string;
  terms: boolean;
  countries: Array<object>;
  privacy: string;
  termsConditions: string;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    private http: HttpClient,
    private countryProvider: CountryProvider,
    private popoverCtrl: PopoverController,
    private apiErrorHandler: ApiErrorHandlerProvider,
    private termsConditionsService: TermsConditionsServiceProvider,
    private tabsService: TabsServiceProvider,
    public urlService: UrlServiceProvider
  ) {
    this.privacy = '#';
    this.termsConditions = '#';
    this.tabsService.hide();
  }

  ngOnInit() {
    this.countries = this.countryProvider.getAll();

    this.termsConditionsService.getPrivacyPolicy().then((url: string) => {
      this.privacy = url;
    });

    this.termsConditionsService.getInviteBarbershop().then((url: string) => {
      this.termsConditions = url;
    });
  }

  invite() {
    this.loading = true;

    this.http.post('/invite', {
      name: this.name,
      email: this.email,
      barbershop: this.barbershop,
      country: this.country,
      barbershopWebsite: this.barbershopWebsite,
      comments: this.comments,
      terms: this.terms,
    }).subscribe((data: any) => {
      this.errors = {};
      this.loading = false;

      let thankYouPopover = this.popoverCtrl.create(RecommendationThankYouPopoverPage,
        {},
        {
          cssClass: 'complete-booking-modal',
          enableBackdropDismiss: false
        });

      thankYouPopover.present();

      thankYouPopover.onDidDismiss(() => {
        this.name = null;
        this.email = null;
        this.barbershop = null;
        this.country = null;
        this.barbershopWebsite = null;
        this.comments = null;
        this.terms = null;

        // Go back to the previous page
        this.navCtrl.pop();
      })
    }, error => {
      this.loading = false;
      this.errors = this.apiErrorHandler.handleError(error);
    }, () => {
    })
  }

  ionViewWillLeave() {
    this.tabsService.show();
  }

}



// WEBPACK FOOTER //
// ./src/pages/invite-barbershop/invite-barbershop.ts